import { Divider, Skeleton } from '@heroui/react';

import formatTimestamp from '~/common/helpers/formatTimestamp';
import { CopyableText } from '~/components/CopyableText';

type TimestampCellProps = {
  timestamp: string;
};

export function TimestampCell({ timestamp }: TimestampCellProps) {
  const { formattedDate, formattedTime } = formatTimestamp(timestamp);

  return (
    <CopyableText
      text={`${formattedDate} ${formattedTime}`}
      data-testid='monitor-pipeline-logs-cell-timestamp'
    >
      <div className='flex items-center gap-2.5'>
        <span className='font-mono text-body-regular-md'>{formattedDate}</span>
        <Divider className='w-[1px] h-[17px] bg-outline' />
        <span className='font-mono text-body-regular-md'>{formattedTime}</span>
      </div>
    </CopyableText>
  );
}

export function TimestampCellSkeleton() {
  return (
    <div className='flex items-center gap-2.5'>
      <Skeleton className='h-5 w-24 rounded' />
      <Skeleton className='w-[1px] h-[17px] rounded' />
      <Skeleton className='h-5 w-32 rounded' />
    </div>
  );
}
